<!-- 商品分类 -->

<template>
    <div class="discount">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1"></div>
                <div class="searchBox flex flex-align-center">
                    <div class="clearfix" style="width:100%">
                        <div class="left search flex flex-align-center">
                            原料单位管理
                        </div>
                        <div class="right searchBtn">
                            <button type="button" @click="addClassify(false)"><i class="el-icon-plus"></i>新增</button>
                        </div>
                    </div>
                </div>
                <div class="HSpace2"></div>
                <div class="tableBox">
                    <div class="tableBoxScroll">
                        <table class="titleTable">
                            <tr>
                                <th>名称</th>
                                <th>操作</th>
                            </tr>
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                               <div class="type_parent">
                                    <!-- <div class="type_title clearfix">
                                        <span class="left type_title_name flex flex-align-center">添加优惠</span>
                                        <span class="right parent_default flex flex-align-center flex-pack-center">
                                            <i class=" iconfont icon-icon02" title="添加" @click="addClassify(false)"></i>
                                        </span>
                                    </div> -->
                                    <!-- <div class="type_parent_item type_active" v-for="(item,ind) in typeData" :style="{height:(item.isOpen&&btn?((item.children.length+1)*9+'%'):'9%')}"> -->
                                    <div class="type_parent_item type_active" v-for="(item,ind) in typeData" style="height:9%;">
                                        <div class="type_parent_text clearfix" style="height:100%;">
                                            <div class="left type_parent_text_left flex flex-align-center">
                                                <span class="parent_default type_name" v-text="item.name"></span>
                                            </div>
                                            <div class="right ss flex flex-align-center flex-pack-center">
                                               <!-- <span style="color: #9cda71;" @click="sorting(true,item,ind)">上移</span>
                                               <span style="color: #9cda71;" @click="sorting(true,item,ind)">上移</span> -->
                                               <!-- <span style="color: #f76260;">排序值:{{item.sequence}}</span> -->
                                            </div>
                                            <span class="right type_parent_text_right flex flex-align-center flex-pack-center" >
                                                <!-- <i class=" iconfont icon-chakanmeal" title="查看商品" @click="showMealInfo(item)"></i> -->
                                                <i class="iconfont icon-bianji" title="修改" @click="upClassify(item,false)"></i>
                                                <i class=" iconfont icon-icon1460188478041" title="删除" @click="delClassify(item,false)"></i>
                                            </span>
                                        </div>
                                        
                                    </div>
                               </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 分页器 -->
                <!-- <div class="pager flex flex-align-center">
                    <div class="pagerCon clearfix">
                        <div class="pagerBtnBox right">
                            <div class="pagerBtn">
                                <span class="prev flex flex-align-center flex-pack-center left"><i class="el-icon-arrow-left"></i></span>
                                <span class="curPageNumber flex flex-align-center flex-pack-center left">1</span>
                                <span class="next flex flex-align-center flex-pack-center left havePage"><i class="el-icon-arrow-right"></i></span>
                            </div>
                        </div>
                        <div class="curPage flex flex-align-center right">第 1 / 9 条</div>
                        <div class="totalPage flex flex-align-center right">共100条</div>
                    </div>
                </div> -->
            </div>
        </div>
        <el-dialog
            class="dialog"
            title="添加/编辑"
            :visible.sync="addJobVisible"
            >
            <div>
                <div class="msgBox clearfix">
                    <div class="left msgItem clearfix" style="width:100%">
                        <span class="left itemName" style="width:150px"><i>*</i>原料单位名称</span>
                        <input type="text" class="left itemInput" v-model="newDiscount.name" placeholder="请输入名称">
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <button type="button" @click="addJobVisible=false" class="cancel">取消</button>
                <button type="button" @click="addDiscount" class="save">保存</button>
            </span>
        </el-dialog>
        <el-dialog
            title="优惠商品详情"
            :visible.sync="mealInfo"
            size="tiny">
            <div>
                <div class="msgBox clearfix">
                    <div class="meal-goods">
                        <div class="tit">
                            <table>
                                <tr>
                                    <th style="width:25%;">商品名</th>
                                    <th style="width:25%;">所属分类</th>
                                    <th style="width:25%;">商品数量</th>
                                    <th style="width:25%;">操作</th>
                                </tr>
                            </table>
                        </div>
                        <div class="list">
                            <table v-if="mealInfoData.length">
                                <tr v-for="(item,index) in mealInfoData" :key="index" >
                                    <td style="width:25%;">{{item.name}}</td>
                                    <td style="width:25%;">{{item.typeName}}</td>
                                    <td style="width:25%;">{{item.setMealQty}}</td>
                                    <td style="width:25%;color:#3068ff;cursor:pointer;" @click="delMealGoods(item)">删除</td>
                                </tr>
                            </table>
                            <div style="padding:10px 0;text-align:center;" v-if="!mealInfoData.length">
                                暂无商品
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <span slot="footer" class="dialog-footer">
                <button type="button" @click="addJobVisible=false" class="cancel">取消</button>
                <button type="button" @click="addJob" class="save">保存</button>
            </span> -->
        </el-dialog>
        <div class="sel-goods" v-if="showSelGoods">
            <selGoods @selOk="selOk" :isDiscount="true" :nowSelClassGoods="nowSelClassGoods" :storeId="curStoreId" :nowSelClass="nowSelClass" @closeSelGoods="closeSelGoods"></selGoods>
        </div>
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    import {BASE_URL} from "../../../urlConfig";
    export default{
        props: ['curStoreId'],
        components:{
        },
    	data () {
    		return {
                // 
                isAllWeek:false,
                setMealIds:[],
                disCoutFirst:[{
                    id:0,
                    name:'暂无'
                },{
                    id:1,
                    name:'会员'
                },{
                    id:2,
                    name:'时间段'
                }],
                weeks:["星期一","星期二","星期三","星期四","星期五","星期六","星期天"],
                levelsList:[],//会员等级列表
                newDiscount:{
                    name:'',
                    id:0
                },
                // 
                nowSelClassGoods:[],//当前所选优惠内的商品
                nowSelClass:{},
                showSelGoods:false,
                printEr:[],
                mealInfo:false,
                fliter_type:"",
                typeList:[],//分类列表
                addJobVisible: false,
                btn:false,//分类下拉三角样式
                typeData:[],
                obj: {
                    name:'',
                    id:'',
                    price:0,
                    typeId:"",
                    kitchenPrintEnabled:0,
                    ipId:"",
                },
                typeBtn: '',
                typeName: '',
                addJobBtn: true,
                systemData:[],
                mealInfoData:[],//优惠商品详情
                nowSelMealId:"",//当前查看的优惠id
                nowSelGoods:[],
                proIds:[],
                canGetClassGoods:true,
    		}
        },
        watch:{
            addJobVisible(val){
                if(!val){
                    this.initData();
                }
            }
        },
        methods: {
            handleChangeWeeksAll(val){
                if(this.isAllWeek){
                    this.newDiscount.week = this.weeks;
                }else{
                    this.newDiscount.week = [];
                }
                },
            getLevels(){
                this.$http({
                    url:"level-list",
                    method:"GET",
                    params:{
                        storeId:this.curStoreId
                    }
                }).then(res=>{
                    let data = res.data;
                    for(let i=0;i<data.length;i++){
                        data[i].nowSetPrice = ""
                    }
                    this.levelsList = data;
                    console.log(data)
                })
            },
            // new add
            handleChangeWeeks(value){
                console.log(value)
                this.newDiscount.week = value;
            },
            check(){
                //正则验证方法
                if(!this.newDiscount.name){
                    this.$message({
                        message: '请输入名称',
                        customClass: 'error'
                    })
                    return true;
                }
                return false;
            },
            // 新增优惠方式
            addDiscount(){
                if(this.check()){
                    return;
                }
                this.$http({
                    url:"material/unit/edit",
                    method:"POST",
                    data:{
                      storeId:this.curStoreId,
                      name:this.newDiscount.name,
                      id:this.newDiscount.id,
                    }
                }).then(res=>{
                    this.$message({
                        message: res.data,
                        customClass: 'success'
                    });
                    this.addJobVisible = false;
                    this.initData();
                    this.getDataList();
                    // if(res.data.code == 200){
                    //     this.$message({
                    //         message: res.data.msg,
                    //         customClass: 'success'
                    //     });
                    //     this.addJobVisible = false;
                    //     this.initData();
                    //     this.getDataList();
                    // }else if(res.data.code == 400){
                    //     this.$message({
                    //         message: res.data.msg,
                    //         customClass: 'error'
                    //     });
                    // }
                })
                
            },
            initData(){
                this.newDiscount = {
                    name:'',
                    id:0
                }
            },
            reduceClassGoods(item){
                console.log(item);
                // return;
                let index;
                let flag = false;
                console.log(this.nowSelClassGoods)
                console.log(item)
                for(let i=0;i<this.nowSelClassGoods.length;i++){
                    if(this.nowSelClassGoods[i].productId == item.productId){
                        flag = true;
                        index = i;
                    }
                }
                if(flag){
                    let nowSelClassGoods = this.nowSelClassGoods;
                    nowSelClassGoods.splice(index,1);
                    this.nowSelClassGoods = nowSelClassGoods;
                    let proIds = [];
                    let setMealIds = [];
                    for(let i=0;i<nowSelClassGoods.length;i++){
                        let obj = {
                            productId:nowSelClassGoods[i].productId,
                            setMealQty:nowSelClassGoods[i].count,
                            // productName:this.nowSelectGoods[i].productName,
                        }
                        if(!nowSelClassGoods[i].setMealEnabled){
                            proIds.push(obj)
                        }else{
                            setMealIds.push(nowSelClassGoods[i].productId);
                        }
                        // proIds.push(obj);
                    }
                    this.proIds = proIds;
                    this.setMealIds = setMealIds;
                }
            },
            closeSelGoods(){
                this.showSelGoods=false;
                // this.getClassGoos();
            },
            //获取优惠内商品
            getClassGoos(){
                if(!this.canGetClassGoods){
                    return;
                }
                console.log(this.nowSelClass)
                this.$http({
                    url:"/meal/get-product",
                    method:"GET",
                    params:{
                        mealId:this.nowSelClass.id,
                    }
                }).then(res=>{
                    this.nowSelClassGoods = res.data;
                    let proIds = []
                    for(let i=0;i<res.data.length;i++){
                        let obj = {
                            productId:res.data[i].productId,
                            setMealQty:res.data[i].count,
                        }
                        proIds.push(obj)
                    }
                    this.proIds = proIds;
                });
            },
            //添加或删除优惠商品
            updateOrAddClass(){
                this.$http({
                    url:"/meal/add-pro",
                    method:"POST",
                    data:{
                        id:this.nowSelClass.id,
                        proIds:this.proIds
                    }
                }).then(res=>{
                    if(res.data.code == 200){
                    }
                });
            },
            selOk(data){
                // this.nowSelGoods = data.nowSelectGoods;
                console.log(data.nowSelectGoods)
                let setMealIds = [];
                // this.nowSelClassGoods = data.nowSelectGoods;
                if(data.nowSelectGoods.length){
                    let nowSelClassGoods = data.nowSelectGoods;
                    for(let i=0;i<data.nowSelectGoods.length;i++){
                        if(data.nowSelectGoods[i].productId){
                            nowSelClassGoods[i].id = data.nowSelectGoods[i].productId;
                        }
                        if(data.nowSelectGoods[i].setMealEnabled){
                            setMealIds.push(data.nowSelectGoods[i].productId);
                        }
                        
                    }
                    this.nowSelClassGoods = nowSelClassGoods;
                    this.nowSelGoods = nowSelClassGoods;
                }
                this.proIds = data.proIds;
                console.log(setMealIds)
                this.setMealIds = setMealIds;
                this.showSelGoods = false;
            },
            // 获取打印数据
            getPrintIpInfo(){
                this.$http({
                url:BASE_URL+"/v1/ip/get-ip",
                method:"GET",
                params:{
                    storeId:this.curStoreId
                    }
                }).then(res=>{
                    this.printEr = res.data;
                    console.log(res);
                });
            },
            // 删除优惠商品
            delMealGoods(item){
                console.log(item)
                if(!this.nowSelMealId){
                    return;
                }
               this.$http({
                    url:"/meal/delete-pro",
                    method:"POST",
                    data:{
                        id:this.nowSelMealId,
                        proIds:[
                            {
                                productId:item.id
                            }
                        ]
                    }
                }).then(res=>{
                    if(res.data.code == 200){
                        this.showMealInfo({id:this.nowSelMealId});
                        this.$message({
                            message: res.data.msg,
                            customClass: 'success'
                        });
                        return;
                    }
                }); 
            },
            // 查看优惠商品详情
            showMealInfo(item){
                this.nowSelMealId = item.id;
                this.mealInfo = true;
                this.$http({
                    url:"/meal/find-pro",
                    method:"GET",
                    params:{
                        mealId:item.id
                    }
                }).then(res=>{
                    this.mealInfoData = res.data;
                });
            },
            //添加或者修改分类
            addJob(){
                if(!this.obj.name){
                    this.$message({
                        message: '优惠名称有误',
                        customClass: 'error'
                    })
                    return;
                }
                if(!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.obj.price)){
                    this.$message({
                        message: '优惠价格有误',
                        customClass: 'error'
                    })
                    return;
                }
                if(!this.obj.typeId){
                    this.$message({
                        message: '请选择优惠所属分类',
                        customClass: 'error'
                    })
                    return;
                }
                if(this.typeBtn == 1){
                    //添加父类
                    let data;
                    if(this.obj.kitchenPrintEnabled){
                        data = {
                            // "id"      : this.$uuid.create(1).hex,
                            // "sequence":-1,
                            "name":this.obj.name,
                            "price":this.obj.price,
                            "typeId":this.obj.typeId,
                            "storeId" : this.$route.params.id,
                            "kitchenPrintEnabled":this.obj.kitchenPrintEnabled,
                            "ipId":this.obj.ipId,
                            proIds:this.proIds,
                            // "parentId": ''
                        }
                    }else{
                        data = {
                            "name":this.obj.name,
                            "price":this.obj.price,
                            "typeId":this.obj.typeId,
                            "storeId" : this.$route.params.id,
                            "kitchenPrintEnabled":this.obj.kitchenPrintEnabled,
                            proIds:this.proIds,
                        }
                        
                    }
                    // let data = {
                    //     // "id"      : this.$uuid.create(1).hex,
                    //     // "sequence":-1,
                    //     "name"    : this.obj.name,
                    //     "price":this.obj.price,
                    //     "typeId":this.obj.typeId,
                    //     "storeId" : this.$route.params.id,
                    //     "kitchenPrintEnabled":this.obj.kitchenPrintEnabled,
                    //     "ipId":this.obj.ipId
                    //     // "parentId": ''
                    // }
                    if(!this.addJobBtn){
                        return;
                    }
                    
                    this.addJobBtn = false;
                    this.$http.post('/meal/add-meal',data).then((res)=>{
                        if(res.data.code == 400){
                            this.$message({
                                message: res.data.msg,
                                customClass: 'error'
                            });
                            this.addJobBtn = true;
                            return;
                        }
                        this.getDataList();
                        this.addJobVisible = false ;
                        this.addJobBtn = true;
                        // this.updateOrAddClass();
                    }).catch(()=>{
                        this.addJobBtn = true;
                    })
                }else if(this.typeBtn == 2){
                    //添加子类
                    let data = {
                        "id"      : this.$uuid.create(1).hex,
                        "name"    : this.obj.name,
                        "storeId" : this.$route.params.id,
                        "parentId": this.obj.id
                    }
                    if(!this.addJobBtn){
                        return;
                    }
                    this.addJobBtn = false;
                    this.$http.put('/product-types',data).then((res)=>{
                        this.getDataList();
                        this.addJobVisible = false ;
                        this.addJobBtn = true;
                    }).catch(()=>{
                        this.addJobBtn = true;
                    })
                }else if(this.typeBtn == 3){
                    this.canGetClassGoods = true;
                    //、、修改父类
                    if(!this.obj.name){
                        this.$message({
                            message: '优惠名称有误',
                            customClass: 'error'
                        })
                        return;
                    }
                    if(!this.obj.typeId){
                        this.$message({
                            message: '请选择优惠所属分类',
                            customClass: 'error'
                        })
                        return;
                    }
                    if(!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.obj.price)){
                        this.$message({
                            message: '优惠价格有误',
                            customClass: 'error'
                        })
                        return;
                    }
                    let data;
                   if(this.obj.kitchenPrintEnabled){
                       data = {
                        "id"      : this.obj.id,
                        "name"    : this.obj.name,
                        "price":this.obj.price,
                        "typeId":this.obj.typeId,
                        "kitchenPrintEnabled":this.obj.kitchenPrintEnabled,
                        "ipId":this.obj.ipId,
                        proIds:this.proIds,

                    }
                   }else{
                      data = {
                        "id"      : this.obj.id,
                        "name"    : this.obj.name,
                        "price":this.obj.price,
                        "typeId":this.obj.typeId,
                        "kitchenPrintEnabled":this.obj.kitchenPrintEnabled,
                        proIds:this.proIds,

                    } 
                   }
                    if(!this.addJobBtn){
                        return;
                    }
                    
                    this.addJobBtn = false;
                    this.$http.post('/meal/update-meal',data).then((res)=>{
                        if(res.data.code == 400){
                            this.$message({
                                message: res.data.msg,
                                customClass: 'error'
                            });
                            this.addJobBtn = true;
                            return;
                        }
                        // this.updateOrAddClass();
                        this.getDataList();
                        this.addJobVisible = false ;
                        this.addJobBtn = true;
                        this.$message({
                            message: '修改成功',
                            customClass: 'success'
                        });
                    }).catch(()=>{
                        this.addJobBtn = true;
                    })
                }else if(this.typeBtn == 4){
                     //、、修改子类
                    let data = {
                        "id"      : this.obj.id,
                        "name"    : this.obj.name,
                        "storeId" : this.$route.params.id,
                        "parentId": this.obj.arId
                    }
                    if(!this.addJobBtn){
                        return;
                    }
                    this.addJobBtn = false;
                    this.$http.put('/product-types',data).then((res)=>{
                        this.getDataList();
                        this.addJobVisible = false ;
                        this.addJobBtn = true;
                    }).catch(()=>{
                        this.addJobBtn = true;
                    })
                }
            },
            //排序
            sorting(boo,item,ind){
                let list = [];
                if( boo ){
                    //上移
                    for (let i = 0, len = this.typeData.length; i < len; i++) {
                        if(ind==0){
                            this.$message({
                                message: '已经是第一项了',
                                customClass: 'error'
                            })
                            return;
                        }
                        let body = {
                            "productTypeId":this.typeData[i].id,
                            "sequence":i
                        };
                        list.push(body)
                        if(ind == i){
                            list[i].sequence = i-1;
                            list[i-1].sequence = i;
                        }
                    }
                }else{
                    if(ind==this.typeData.length-1){
                        this.$message({
                            message: '已经是最后一项了',
                            customClass: 'error'
                        })
                        return;
                    }
                    let num=-1;
                    for (let i = 0, len = this.typeData.length; i < len; i++) {
                        let body = {
                            "productTypeId":this.typeData[i].id,
                            "sequence":i
                        };
                        list.push(body)
                        if(ind == i){
                            list[i].sequence = i+1;
                            num = i+1;
                        }
                        if(num == i ){
                            list[num].sequence = i-1;
                        }
                    }
                }
                this.$http.put('/product-sequence',{"products":list}).then((res)=>{
                    this.getDataList();
                }).catch((err) => {
                });
            },
            getDataList(){
                this.$http({
                    url:"material/unit/list",
                    method:"GET",
                    params:{
                        storeId:this.curStoreId,
                        page:0,
                        size:10000
                    }
                }).then(res=>{
                    this.typeData = res.data;
                    console.log(this.typeData);
                })
            },
            addClassify(id){
                // this.$router.push({name:"discountManaEdit",query:{type:"add"}});
                this.addJobVisible = true;
                return;
                this.initData();
                //添加分类
                this.typeName = "添加折扣方式"
                this.canGetClassGoods = false;
                this.obj = {
                    name:'',
                    id:'',
                    price:0,
                    kitchenPrintEnabled:0,
                };
                this.nowSelClassGoods = [];
                this.addJobVisible = true ;
                this.obj.id = id?id:'';
                this.typeBtn = id?2:1;
                // this.nowSelClass = {};
            },
            upClassify(item,oitem){
                console.log(item);
                this.newDiscount = {
                    id:item.id,
                    name:item.name,
                }
                this.addJobVisible = true;
            },
            delClassify(item,oitem){
                this.$confirm(`是否删除 ${item.name} ?`, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                    //删除
                    this.$http({
                        url:"material/unit/delete",
                        method:"GET",
                        params:{
                            id:item.id
                        }
                    }).then(res=>{
                        if(res.data.code == 200){

                        }else{
                            this.$message({
                                message: res.data,
                                customClass: 'success'
                            })
                        }
                        this.getDataList();
                    });
                }).catch(() => {});

            },
            handle(item,ind){
                if(this.typeData[ind].isOpen){
                    this.btn = !this.btn;
                }else{
                    this.btn = true ;
                }
                for(var i = 0,len = this.typeData.length; i < len;i++){
                   this.typeData[i].isOpen = false;
                }
                this.typeData[ind].isOpen  = true;
            }
        },
        activated: function () {
            this.getDataList();
            sessionStorage.setItem("modifyDiscountItem","{}");
            // this.getPrintIpInfo();
            
            //就怕sequence会大于数组的长度
            // this.$http.get('/get-type?storeId='+this.$route.params.id).then((res)=>{
            //     console.log(res.data)
            //     let body = res.data;
            //     // this.systemData = res.data.systemData;
            //     let newArr = []; 
            //     for (let i = 0, len = body.length; i < len; i++) {
            //         if ( !body[i].parent ) {
            //             body[i].isOpen = false;
            //             newArr.push(body[i]);
            //             newArr[newArr.length-1].children = [];
            //             for (let j = 0, len = body.length; j < len; j++) {
            //                 if ( body[j].parent&&body[i].id==body[j].parent.id) {
            //                     newArr[newArr.length-1].children.push(body[j]);
            //                 }
            //             }
            //         }
            //     }
            //     let list = [];
            //     for (let i = 0, len = newArr.length; i < len; i++) {
            //         let bodys = {
            //             "productTypeId":newArr[i].id,
            //             "sequence":i
            //         };
            //         list.push(bodys)
            //     }
            //     if(!list.length){
            //         return;
            //     }
            //     this.$http.put('/product-sequence',{"products":list}).then((res)=>{
            //         this.getDataList();
            //     }).catch((err) => {
            //     });
            // }).catch((err) => {
            // });
        }
    }
</script>
<style lang="scss">
    @import '../../../../static/css/common.scss';
    @import '../../tableTemplate/tableTem.scss';
    @import '../../tableTemplate/el-dialog.scss';
	@import "matUnit.scss";
</style>



// WEBPACK FOOTER //
// matUnit.vue?7d69b432